export const iconFontAwesomeWritingBookBookmark = (
	<i className="fa-solid fa-book-bookmark"></i>
);
